export enum PersonioActiveTabEnum {
    SETTINGS,
    EXCLUSION_LIST,
}
